import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import Modal from 'react-responsive-modal';
import { connect } from 'react-redux';
import WorkListItem from './WorkListItem';
import './WorkTable.css';

class WorkTable extends React.Component {
  state = {
    reasonMsg: '',
    deviceNameAndStatus: '',
    showModal: false,
  };

  modalStyles = {
    modal: {
      top: '400px',
      minWidth: '500px',
      minHeight: '400px',
      padding: '2rem',
      maxHeight: '90vh',
      overflowY: 'auto',
    },
  };

  columnsCount = () => 14;

  renderHeader = () => {
    const { translate } = this.props;

    return (
      <thead>
        <tr className="report-table-header_worklist">
          <th className="report-table-th_worklist">{translate('work_list.column_task.shipmentId')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.createdAt')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.subcontractorName')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.customerName')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.consignorName')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.customerStreetAddress')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.customerPostalCode')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.devicesName')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.deviceAdditionalProductName')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.customerCity')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.customerPhone')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.date')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.status')}</th>
          <th className="report-table-th_worklist">{translate('work_list.column_task.parking-info')}</th>
        </tr>
      </thead>
    );
  };

  renderLoadingInfo = () => {
    const {
      translate,
      isLoading,
    } = this.props;
    return isLoading
      ? (
        <tr className="report-table-row_worklist">
          <td colSpan={this.columnsCount()}
              className="report-table-cell_worklist_no_border">
            {translate('work_list.search.loading')}
          </td>
        </tr>
      )
      : null;
  };

  reasonModalHandler = (reasonModalData) => {
    this.setState({
      reasonMsg: reasonModalData.msg,
      deviceNameAndStatus: reasonModalData.deviceNameAndStatus,
      showModal: reasonModalData.showReasonModal,
    });
  }

  renderResult = () => {
    const {
      translate, currentLanguage, data, isLoading,
    } = this.props;
    if (isLoading) {
      return null;
    }

    return (
      <React.Fragment>
        {data.length === 0 && (
          <tr className="report-table-row_worklist">
            <td colSpan={this.columnsCount()}
                className="report-table-cell_worklist_no_border">
              {translate('work_list.search.no_data_found')}
            </td>
          </tr>
        )}

        {data.map((order) => (
          <WorkListItem key={order.id}
                        item={order}
                        reasonModalHandler={this.reasonModalHandler}
                        currentLanguage={currentLanguage}
                        translate={translate} />
        ))}
      </React.Fragment>
    );
  };

  render() {
    const { translate } = this.props;
    const { reasonMsg, deviceNameAndStatus, showModal } = this.state;
    return (
      <div>
        <div>
          <Modal open={showModal} styles={this.modalStyles} onClose={() => { this.setState({ showModal: false }); }}>
            <div>
              <h3>
                {' '}
                {deviceNameAndStatus}
                {' '}
              </h3>
              <div>
                <br />
                <h4>
                  {translate('work_list.column_task.device-not-installed-reason')}
                  {' '}
                  :
                </h4>
                <div>
                  {reasonMsg}
                </div>
              </div>
            </div>
          </Modal>
        </div>
        <table className="report-table_worklist">
          {this.renderHeader()}
          <tbody>
            {this.renderLoadingInfo()}
            {this.renderResult()}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);

  return {
    currentLanguage: activeLanguage?.code || 'fi',
    translate: getTranslate(locale),
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(WorkTable);
